// ABOUTME: Picks Production Scheduling's chrome from the site's sparkNav setting.
// ABOUTME: Either layout renders the whole frame around the page, so the two are interchangeable here.

import ApplicationContext from "domain/ApplicationContext";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import React from "react";
import LegacyApplicationLayout from "./LegacyApplicationLayout";
import SparkApplicationLayout from "./spark/SparkApplicationLayout";

export default function ApplicationLayout({ children }) {
  const applicationContext = useApplicationContext();

  if (ApplicationContext.isSparkNavEnabled(applicationContext)) {
    return <SparkApplicationLayout>{children}</SparkApplicationLayout>;
  }

  return <LegacyApplicationLayout>{children}</LegacyApplicationLayout>;
}
